const simulation = () => import('@/views/main/simulation/simulation.vue')
export default {
  path: '/main/simulation',
  name: 'simulation',
  component: simulation,
  children: []
}
